import { Button, Typography } from '@mui/material';
import { useRef } from 'react';

function FileSelectForm({children}) {
  return (
    {...children}
  );
}

/** ファイル選択ボタン
 * @param label ボタンに表示する文字列. デフォルトでは'ファイル選択'.
 * @param onSelectFiles ファイル選択時挙動 (files) => void. filesはmultipleの指定によらず、常にFileListオブジェクトであることに注意.
 * @param accept 選択対象のファイルの固有ファイル型指定子 (cf. https://developer.mozilla.org/ja/docs/Web/HTML/Reference/Elements/input/file#固有ファイル型指定子)
 * @param multiple 複数ファイル選択を許すか？ デフォルトはfalse
 * @param buttonProps ボタンプロパティ
 */
FileSelectForm.SelectButton = ({label = 'ファイル選択', onSelectFiles, onClick, accept='', multiple=false, ...buttonProps}) => {
  
  const handleChange = (e) => {    
    onSelectFiles(e.target.files);
  }

  const handleClick = (e) => {
    e.target.value = "";
    if (onClick) {
      onClick(e);
    }
  }

  return (
    <Button
      component="label"
      variant="contained"
      onClick={handleClick}
      {...buttonProps}
    >
      {label}
      <input
        type="file"
        style={{display: 'none'}}
        accept={accept}
        multiple={multiple}
        onChange={handleChange}
      />
    </Button>
  )
};

/** ファイル名表示。
 * @param fileName ファイル名
 * @param getNameText ファイル名テキストを取得する (fileName) => String. デフォルトでは、`ファイル名 : ${fileName}`が入る。
 * @param textProps 表示テキストのプロパティ
 */
FileSelectForm.FileNameDisplay = ({
  fileName,
  getNameText = (fileName) => `ファイル名 : ${fileName}`,
  ...textProps
}) => {

  return (
    fileName
      ? <Typography {...textProps}>
          {getNameText(fileName)}
        </Typography>
      : null    
  )
}

/** ファイルサイズ表示。
 * @param fileSize ファイルサイズ (byte単位)
 * @param getSizeText ファイルサイズテキストを取得する (fileSize) => String. デフォルトでは、`サイズ : ${Math.floor(fileSize / 1024)} KB`が入る。
 * @param textProps 表示テキストのプロパティ
 */
FileSelectForm.FileSizeDisplay = ({
  fileSize,
  getSizeText = (fileSize) => `サイズ : ${Math.floor(fileSize / 1024)} KB`,
  ...textProps
}) => {
  return (
    fileSize
      ? <Typography {...textProps}>
          {getSizeText(fileSize)}
        </Typography>
      : null    
  )
}

export default FileSelectForm;